import { go, getCurrentPageUrl } from "@/utils/location"

const isCloudflareCaptchaChallenge = (response) => {
  if (response.status === 403) {
    //  We have to clone the response object here because its content can only be consumed once.
    // If we would consume it here for error processing we cannot consume it again down the line.
    const localResponse = response.clone()
    // Make sure we only react on 403s from Cloudflare
    return localResponse.text().then((resText) => {
      return (
        resText.includes("security by") &&
        resText.includes("Cloudflare") &&
        resText.includes("Ray ID") &&
        resText.includes("captcha")
      )
    })
  } else {
    return Promise.resolve(false)
  }
}

export const redirectToCloudflareCaptchaOnError = async (response) => {
  if (response.status === 429) {
    go("/429")
    return Promise.reject(new Error("Too many requests"))
  } else {
    return isCloudflareCaptchaChallenge(response).then((isChallenge) => {
      if (isChallenge) {
        go(`/nc/captcha?target_url=${getCurrentPageUrl()}`)
        return Promise.reject(new Error("Received Captcha Challenge"))
      } else {
        return response
      }
    })
  }
}
